import { localStorageSetItemWithQuotaRecovery } from './localStorageQuota';

function key(workspaceId: string, gradeId: string): string {
  return `cp.trackAliasOrder.v1.${workspaceId}.${gradeId}`;
}

export function loadTrackAliasOrderMap(workspaceId: string, gradeId: string): Record<string, string[]> {
  if (!workspaceId || !gradeId) return {};
  try {
    const raw = window.localStorage.getItem(key(workspaceId, gradeId));
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    const out: Record<string, string[]> = {};
    Object.entries(parsed as Record<string, unknown>).forEach(([trackName, aliases]) => {
      if (!trackName.trim() || !Array.isArray(aliases)) return;
      const cleaned = aliases
        .map((v) => (typeof v === 'string' ? v.trim() : ''))
        .filter((v) => v.length > 0);
      out[trackName] = Array.from(new Set(cleaned));
    });
    return out;
  } catch {
    return {};
  }
}

export function saveTrackAliasOrderMap(
  workspaceId: string,
  gradeId: string,
  value: Record<string, string[]>
): void {
  if (!workspaceId || !gradeId) return;
  localStorageSetItemWithQuotaRecovery(key(workspaceId, gradeId), JSON.stringify(value));
}
